import { sum } from "d3-array";

import { slidingWindow } from "../utils";
import { TypicalPrice as defaultOptions } from "./defaultOptionsForComputation";

/**
 * Typical Price Calculator
 *
 * Calculates the Simple Moving Average of Typical Price.
 * Typical Price = (High + Low + Close) / 3
 * Result = SMA(Typical Price, Period)
 *
 * @returns {Function} Calculator function with options and undefinedLength methods
 */
export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize } = options;

    // Calculate Typical Price for each bar
    const typicalPriceData = data.map((d) => {
      const high = d.high;
      const low = d.low;
      const close = d.close;
      return (high + low + close) / 3;
    });

    // Calculate SMA of Typical Price
    const typicalPriceSMA = slidingWindow()
      .windowSize(windowSize)
      .accumulator((values) => sum(values) / windowSize);

    const calculatedData = typicalPriceSMA(typicalPriceData);

    return calculatedData;
  }

  calculator.undefinedLength = function () {
    return options.windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
